import React from 'react';
import { Box } from '@mui/material';

export default function RightSidebarContainer({
  children,
  sticky = false,
  topOffset = 64,
  sx = {},
  ...props
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: 320,
        flexShrink: 0,
        ...(sticky && { position: 'sticky', top: topOffset }),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
